import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();
const Cancel = () => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                    stroke="#140B1D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0001 11L11.0001 19M11.0001 11L19.0001 19M28.3334 15C28.3334 22.3638 22.3639 28.3333 15.0001 28.3333C7.63628 28.3333 1.66675 22.3638 1.66675 15C1.66675 7.63616 7.63628 1.66663 15.0001 1.66663C22.3639 1.66663 28.3334 7.63616 28.3334 15Z"
                    stroke="#140B1D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m10 6-4 4m0-4 4 4m4.666-2A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0Z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Cancel;
